import { FilledStatus } from '@/lib/enum/filled-status'
import { AddressType } from '@/types/enums'

interface AddressEntityInput {
  id?: number
  type?: AddressType | string | null
  street_address?: string | null
  apartment?: string | null
  zipcode?: string | null
  city?: string | null
  state?: string | null
  country?: string | null
  status?: FilledStatus | string | null
  created_at?: string
}

export class AddressEntity {
  public id: number
  public type: AddressType
  public street_address: string
  public apartment: string
  public zipcode: string
  public city: string
  public state: string
  public country: string
  public status: FilledStatus
  public created_at: string

  constructor(address: AddressEntityInput) {
    this.id = address.id as number
    this.type = address.type as AddressType
    this.street_address = address.street_address as string
    this.apartment = address.apartment as string
    this.zipcode = address.zipcode as string
    this.city = address.city as string
    this.state = address.state as string
    this.country = address.country as string
    this.status = address.status as FilledStatus
    this.created_at = address.created_at as string
  }

  get fullAddress() {
    return `${this.street_address} ${this.apartment} ${this.city} ${this.state} ${this.zipcode} ${this.country}`
  }
}
